import { Label, LabelMap } from 'util/fields-labels/model-fieldsLabels'
import { flattenKeys } from 'util/object'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'

import { AntecedentePuericulturaModel } from '../antecedentes/model'
import { FinalizacaoAtendimentoFormModel } from '../finalizacao'
import { PrenatalPartoNascimentoModel } from '../objetivo/puericultura/model'
import { MedicamentoFormModel } from '../plano/prescricao-medicamento/model-prescricao'

const PRENATAL_PARTO_NASCIMENTO_FORM_LABELS: Label<PrenatalPartoNascimentoModel & AntecedentePuericulturaModel> = {
  label: 'Pré-natal, parto e nascimento',
  fields: {
    apgar: {
      label: 'Apgar',
      fields: {
        apgarUm: { label: '1º minuto' },
        apgarCinco: { label: '5º minuto' },
        apgarDez: { label: '10º minuto' },
      },
    },
    antropometriaAoNascer: {
      label: 'Antropometria ao nascer',
      fields: {
        comprimento: { label: 'Comprimento (cm)' },
        perimetroCefalico: { label: 'Perímetro cefálico (cm)' },
        peso: { label: 'Peso (kg)' },
      },
    },
    idadeGestacional: { label: 'Idade gestacional' },
    tipoGravidez: { label: 'Tipo de gravidez' },
    tipoParto: { label: 'Tipo de parto' },
    dataAtualizacao: null,
  },
}
const AGENDAR_CONSULTAS_FORM_LABELS = {
  data: { label: 'Data do agendamento' },
  horario: { label: 'Horário do agendamento' },
  lotacao: { label: 'Profissional' },
  isForaUbs: { label: 'Fora da UBS' },
  localAtendimento: { label: 'Local de atendimento' },
  observacoes: { label: 'Observações' },
}

const FINALIZACAO_ATENDIMENTO_FORM_LABELS: Label<FinalizacaoAtendimentoFormModel> = {
  label: 'Finalização do atendimento',
  fields: {
    conduta: { label: 'Conduta' },
    condutasOdonto: { label: 'Conduta' },
    tipoAtendimento: { label: 'Tipo de atendimento' },
    tipoConsulta: { label: 'Tipo de consulta' },
    agendamentoConsultas: {
      label: 'Agendar consulta',
      fields: {
        avulsa: {
          label: 'Consulta avulsa',
          fields: AGENDAR_CONSULTAS_FORM_LABELS,
        },
        proximasConsultas: {
          label: 'Próximas consultas',
          fields: {
            proximaConsultaOdontologica: {
              label: 'Próxima consulta odontológica',
              fields: AGENDAR_CONSULTAS_FORM_LABELS,
            },
            proximaConsultaPreNatal: {
              label: 'Próxima consulta pré-natal',
              fields: AGENDAR_CONSULTAS_FORM_LABELS,
            },
          },
        },
      },
    },
    atendimentoCompartilhadoLotacao: { label: 'Atendimento compartilhado' },
    desfechoAtendimento: {
      label: '',
      fields: {
        manterCidadaoLista: { label: 'Liberar cidadão' },
        atendimento: {
          label: '',
          fields: {
            agendado: { label: 'Próximos agendamentos do dia' },
            equipe: { label: 'Equipe' },
            responsavel: { label: 'Profissional' },
            tiposServico: { label: 'Tipo de serviço' },
          },
        },
      },
    },
    fichasNotificacaoCasoSuspeito: { label: 'Ficha de notificação de caso suspeito' },
    fornecimento: { label: 'Fornecimento' },
    procedimentosAdministrativos: { label: 'Procedimentos administrativos (SIGTAP)' },
    racionalidadeEmSaude: { label: 'Racionalidade em saúde (Exceto alopatia/convencional)' },
    cidadaoPresente: { label: 'Cidadão participou do atendimento' },
    tipoParticipacaoCidadao: { label: 'Forma de participação do cidadão' },
    tipoParticipacaoProfissionalConvidado: { label: 'Forma de participação do profissional convidado' },
  },
}

const MEDICAMENTO_FORM_LABELS: Label<MedicamentoFormModel> = {
  label: 'Medicamentos',
  fields: {
    registroManual: { label: 'Registro manual' },
    concentracaoText: { label: 'Concentração' },
    viaAdministracao: { label: 'Via de administração' },
    unidadeMedidaDose: { label: 'Unidade de medida' },
    tipoReceita: { label: 'Tipo de receita' },
    codigoPrescricaoDigital: null,
    formaFarmaceutica: { label: 'Forma farmacêutica' },
    dose: null,
    qtDose: { label: 'Quantidade da dose' },
    qtDoseManha: { label: 'Dose de manhã' },
    qtDoseTarde: { label: 'Dose à tarde' },
    qtDoseNoite: { label: 'Dose à noite' },
    tipoDose: { label: 'Tipo de dose' },
    tipoFrequencia: { label: 'Tipo de frequência' },
    intervaloDose: { label: 'Intervalo da dose' },
    frequenciaDose: { label: 'Frequência da dose' },
    quantidadePeriodoFrequenciaTurno: { label: 'Qtd. por período/turno' },
    unidadeMedidaTempoFrequenciaTurno: { label: 'Unidade de tempo (frequência)' },
    turno: { label: 'Turno' },
    posologia: { label: 'Posologia' },
    dataInicioTratamento: { label: 'Data de início do tratamento' },
    dataFimTratamento: { label: 'Data de fim do tratamento' },
    duracao: { label: 'Duração' },
    escalaDuracao: { label: 'Unidade de duração' },
    quantidade: { label: 'Quantidade' },
    usoContinuo: { label: 'Uso contínuo' },
    recomendacoes: { label: 'Recomendações' },
    unidadeFornecimento: { label: 'Unidade de fornecimento' },
    disponibilidade: { label: 'Disponibilidade no Hórus' },
    frequenciaDuracao: { label: 'Frequência/Duração' },
    receitaUsoContinuoGrupoId: { label: 'Renovação de receita' },
    id: null,
    editingId: null,
    principioAtivoCombo: null,
    principioAtivoText: null,
    isVersaoAnterior: null,
    isEditFirstLoad: null,
    totalDoseError: null,
    turnosError: null,
  },
}

export const soapFormLabels: LabelMap<Required<SoapState>> = {
  acompanhamentoPreNatal: {
    label: 'Acompanhamento pré-natal',
    fields: {
      idadeGestacional: { label: 'Idade gestacional' },
    },
  },
  subjetivo: {
    label: 'Subjetivo',
    fields: {
      texto: { label: 'Campo aberto' },
      motivos: { label: 'Motivo da consulta (CIAP 2)' },
    },
  },
  objetivo: {
    label: 'Objetivo',
    fields: {
      texto: { label: 'Campo aberto' },
      dum: { label: 'DUM' },
      medicoes: {
        label: 'Antropometria, sinais vitais e glicemia capilar',
        fields: {
          altura: { label: 'Altura (cm)' },
          circunferenciaAbdominal: { label: 'Circunferência abdominal (cm)' },
          frequenciaCardiaca: { label: 'Frequência cardíaca (bpm)' },
          frequenciaRespiratoria: { label: 'Frequência respiratória (mpm)' },
          glicemia: { label: 'Glicemia capilar (mg/dL)' },
          perimetroCefalico: { label: 'Perímetro cefálico (cm)' },
          perimetroPanturrilha: { label: 'Perímetro da panturrilha (cm)' },
          peso: { label: 'Peso (kg)' },
          pressaoArterialDiastolica: { label: 'Pressão arterial (mmHg)' },
          pressaoArterialSistolica: { label: 'Pressão arterial (mmHg)' },
          saturacaoO2: { label: 'Saturação de O2 (%)' },
          temperatura: { label: 'Temperatura (°C)' },
          tipoGlicemia: { label: 'Momento da coleta' },
        },
      },
      resultadosExames: { label: 'Resultados de exames' },
      atendimentosEspecificos: {
        label: 'Atendimentos específicos',
        fields: {
          ivcf: { label: 'IVCF-20' },
          ivcfCache: null,
          puericultura: {
            label: 'Puericultura',
            fields: {
              prenatalPartoNascimento: PRENATAL_PARTO_NASCIMENTO_FORM_LABELS,
              tipoAleitamento: { label: 'Tipo de aleitamento' },
              alteracoesFenotipicas: { label: 'Alterações fenotípicas' },
              fatoresRisco: { label: 'Fatores de risco' },
              marcosDesenvolvimento: { label: 'Marcos de desenvolvimento' },
              dataNascimentoReferencia: null,
              hasPuericultura: null,
              medicaoAnteriorPerimetroCefalico: null,
              mChatRf: {
                label: 'M-CHAT-R/F™',
                fields: {
                  mchat: {
                    label: 'M-CHAT-R™',
                  },
                  consultaSeguimento: {
                    label: 'Entrevista de seguimento',
                  },
                },
              },
            },
          },
        },
      },
      necessidadesEspeciais: { label: 'Paciente com necessidades especiais' },
      vacinacaoEmDia: { label: 'Vacinação em dia?' },
      marcadoresConsumoAlimentar: { label: 'Marcadores de consumo alimentar' },
      anexoArquivos: { label: 'Anexo de arquivos' },
    },
  },
  avaliacao: {
    label: 'Avaliação',
    fields: {
      texto: { label: 'Campo aberto' },
      alergias: { label: 'Alergias' },
      problemasECondicoes: { label: 'Problemas e condições' },
      necessidadeProtese: { label: 'Necessidade de prótese' },
      tiposVigilancia: { label: 'Tipos de vigilância' },
      encerrarGestacao: {
        label: 'Encerrar gestação',
        fields: { dataDesfecho: { label: 'Data' }, tipoGravidez: { label: 'Tipo de gravidez' } },
      },
    },
  },
  plano: {
    label: 'Plano',
    fields: {
      texto: { label: 'Campo aberto' },
      atestado: { label: 'Atestados' },
      encaminhamentoExterno: { label: 'Encaminhamentos' },
      intervencoesProcedimentos: {
        label: 'Intervenções e/ou procedimentos clínicos realizados',
        fields: {
          ciaps: { label: 'CIAP 2' },
          procedimentosPlano: {
            label: 'SIGTAP',
            fields: {
              codigosProcedimentosAutomaticosExcluidos: null,
              procedimentos: null,
            },
          },
        },
      },
      odontologia: {
        label: 'Evoluções odontológicas',
        fields: {
          limiteProcedimentos: { label: '' },
          odontograma: {
            label: 'Odontograma',
            fields: {
              cache: null,
              dentes: { label: 'Dentes' },
              arcadas: { label: 'Arcadas' },
              dentesSupranumerarios: { label: 'Dentes supranumerários' },
              outros: { label: 'Outros' },
              possuiAparelho: { label: 'Possui aparelho' },
              possuiContencao: { label: 'Possui contenção' },
              proteseTotalInferior: { label: 'Prótese total inferior' },
              proteseTotalSuperior: { label: 'Prótese total superior' },
            },
          },
          periodontia: {
            label: 'Periodontia',
            fields: {
              periogramaSimplificado: {
                label: 'Periograma simplificado',
                fields: {
                  avaliacaoSextante1: { label: 'S1' },
                  avaliacaoSextante2: { label: 'S2' },
                  avaliacaoSextante3: { label: 'S3' },
                  avaliacaoSextante4: { label: 'S4' },
                  avaliacaoSextante5: { label: 'S5' },
                  avaliacaoSextante6: { label: 'S6' },
                  observacao: { label: 'Observações' },
                  error: null,
                },
              },
              periogramaCompleto: {
                label: 'Periograma completo',
                fields: {
                  dados: { label: 'Periograma completo' },
                  observacao: { label: 'Observações' },
                },
              },
              evolucoes: { label: 'Registros de procedimentos' },
            },
          },
          tecidosMoles: { label: 'Tecidos moles e duros' },
        },
      },
      prescricaoMedicamento: {
        label: 'Prescrição de medicamentos',
        fields: {
          medicamentos: MEDICAMENTO_FORM_LABELS,
          alreadyPrinted: null,
          replicateStorage: null,
          prescricaoDigital: null,
        },
      },
      orientacao: { label: 'Orientações ao cidadão' },
      solicitacoesExame: { label: 'Solicitação de exames' },
      startObservacao: { label: 'Cidadão em observação' },
      cuidadosCompartilhado: {
        label: 'Compartilhamento de cuidado',
        // TODO(@Supernova): Issue #18354
        fields: {
          cbo: { label: 'CBO' },
          unidadeSaude: { label: 'Unidade de saúde/Serviço de referência' },
          lotacao: { label: 'Profissional' },
          lotacaoSolicitante: { label: 'Profissional solicitante' },
          prioridade: { label: 'Classificação de prioridade' },
          discussao: { label: 'Discussão de caso clínico' },
          problemasECondicoes: {
            label: 'Problemas/condições',
            fields: {
              ciap: { label: 'CIAP 2' },
              cid10: { label: 'CID 10' },
            },
          },
          cidadaoAceitaAtendTic: { label: 'Cidadão aceita TIC' },
          tipo: { label: 'Encaminhamento' },
          lastUpdate: null,
          atendimentoProfissional: null,
        },
      },
    },
  },
  finalizacao: FINALIZACAO_ATENDIMENTO_FORM_LABELS,
  antecedentes: {
    label: 'Ancentedentes',
    fields: {
      familiar: { label: '', fields: { ciaps: { label: 'Lista de problemas dos familiares' } } },
      pessoal: {
        label: '',
        fields: {
          texto: { label: 'Campo aberto' },
          cirurgiasInternacoes: { label: 'Antecedentes hospitalares' },
          informacoesObstetricas: {
            label: 'Informações obstétricas',
            fields: {
              abortos: { label: 'Abortos' },
              filhosVivos: { label: 'Vivem' },
              gestaPrevias: { label: 'Gestas prévias' },
              nascidosVivos: { label: 'Vivos' },
              natimortos: { label: 'Mortos' },
              obitoAntesPrimeiraSemana: { label: 'Mortos na 1ª semana' },
              obitoAposPrimeiraSemana: { label: 'Mortos depois da 1ª semana' },
              partoMenosDeUmAno: { label: 'Desfecho da última gestação aconteceu há menos de um ano' },
              partos: { label: 'Partos realizados' },
              partosCesareas: { label: 'Cesáreas' },
              partosDomiciliares: { label: 'Partos domiciliares' },
              partosVaginais: { label: 'Vaginais' },
              recemNascidoAbaixo: { label: 'Menos de 2500g' },
              recemNascidoAcima: { label: 'Mais de 4500g' },
              dataAtualizacao: null,
            },
          },
          puericultura: PRENATAL_PARTO_NASCIMENTO_FORM_LABELS,
        },
      },
    },
  },
  preNatal: {
    label: 'Pré natal',
    fields: {
      alturaUterina: { label: 'Altura uterina (cm)' },
      batimentoCardiacoFetal: { label: 'Batimento cardíaco fetal (bpm)' },
      edema: { label: 'Edema' },
      gravidezPlanejada: { label: 'Gravidez planejada' },
      movimentacaoFetal: { label: 'Movimentação fetal' },
      tipoGravidez: { label: 'Tipo de gravidez' },
    },
  },
  lembretes: { label: 'Lembretes' },
  problemasECondicoes: { label: 'Lista de problemas/condições' },
  vacinacao: {
    label: 'Vacinação',
    fields: {
      condicoesVacinacao: {
        label: 'Condições',
        fields: {
          condicao: { label: 'Condição gestante, puérpera ou nenhuma' },
          viajante: { label: 'Viajante' },
          comunicanteHanseniase: { label: '' },
        },
      },
      finalizacaoVacinacao: FINALIZACAO_ATENDIMENTO_FORM_LABELS,
      imprimirAtendimento: null,
      registroVacinacao: null,
    },
  },
  medicamentosInterromper: { label: 'Medicamentos em uso/tratamento concluído' },
  medicoesAnteriores: { label: 'Medições (lateral do atendimento)', noFieldsPlaceholder: 'Antropometria' },
  imprimirAtendimento: null,
  retificacaoAtendimento: null,
}

export const soapFieldPaths = flattenKeys(soapFormLabels, [
  'label',
  'fields',
  'noFieldsPlaceholder',
  'imprimirAtendimento',
])
